import { useCurrentAccount } from '@/composables/useCurrentAccount';
import { computed } from 'vue';

// Not contact data, UI copy: the greeting CUSP prefills in the chat. Both
// products used the same sentence before FLOK-1661, which is why the partner
// payload carries a number and not a link.
const WHATSAPP_GREETING = 'Hola! Estoy en mi Panel de Control y necesito ayuda con algo \u{1F64B}';

/**
 * The WhatsApp line that answers this customer: whoever their partner is, not
 * whichever product they are in (FLOK-1661 replaces FLOK-1646).
 *
 * The per-country override Cleepo carried is deliberately gone with it. A
 * partner has one support WhatsApp, and the Mexican number stays reachable as
 * the "México y LATAM" row of `support_phones`. If a Mexican Cleepo customer
 * must get a Mexican *WhatsApp* again, that is a per-country field on the
 * partner in CXM, not a country map back in this repo.
 */
export const useSupportWhatsappLink = () => {
  const { account } = useCurrentAccount();

  const contacts = computed(() => account.value?.partner?.contacts);

  const whatsappLink = computed(() => {
    const phone = contacts.value?.support_whatsapp;
    if (!phone) return '';

    const url = new URL('https://api.whatsapp.com/send');
    // CXM stores E.164; the send endpoint wants bare digits.
    url.searchParams.set('phone', phone.replace(/\D/g, ''));
    url.searchParams.set('text', WHATSAPP_GREETING);
    return url.toString();
  });

  return {
    whatsappLink,
    whatsappLabel: computed(() => contacts.value?.support_whatsapp_label ?? ''),
  };
};
